import Vue from "vue";
import { fetchWithErrorHandling, fetchToJsonWithErrorHandling } from "@/infrastructure/network";
import { ProductVO } from "@/infrastructure/product-vo";

export class SystemService {
  static appRoot = `${process.env.VUE_APP_API_URL}`

  static apiRoot = `${process.env.VUE_APP_API_URL}/api`;

  static tokenKey = "accessToken";

  /**
   * 表紙画像の URL を取得します。
   * @param url 表紙画像。
   */
  public static getImageUrl(url: string): string {
    if (url !== '') {
      return this.appRoot + url;
    }
    return '';
  }

  /**
   * 大きい画像の URL を取得します。
   * @param productId 製品 ID 。
   */
  public static getImageUrlOfLarge(productId: string): string {
    return `${this.appRoot}/Images/Products/${productId}_P512x512.png?timestamp=${Date.now()}`;
  }

  /**
   * 中サイズの画像の URL を取得します。
   * @param productId 製品 ID 。
   */
  public static getImageUrlOfMiddle(productId: string): string {
    return `${this.appRoot}/Images/Products/${productId}_P166x166.png?timestamp=${Date.now()}`;
  }

  /**
   * 小さい画像の URL を取得します。
   * @param productId 製品 ID 。
   */
  public static getImageUrlOfSmall(productId: string): string {
    return `${this.appRoot}/Images/Products/${productId}_P90x90.png?timestamp=${Date.now()}`;
  }

  /**
   * 商品を取得します。
   */
  public static async getProducts(): Promise<ProductVO[]> {
    const url = `${SystemService.apiRoot}/product`;

    return fetchToJsonWithErrorHandling(
      url, {
        method: "GET",
        mode: "cors",
      },
    ).catch((error: Error) => {
      console.error(error.stack);
      throw error;
    });
  }

  /**
   * おすすめリストを取得します。
   */
  public static async getRecommend(): Promise<ProductVO[]> {
    const url = `${SystemService.apiRoot}/recommend`;

    return fetchToJsonWithErrorHandling(
      url, {
        method: "GET",
        mode: "cors",
      },
    ).catch((error: Error) => {
      console.error(error.stack);
      throw error;
    });
  }

  /**
   * お知らせを取得します。
   */
  public static async getInfo(): Promise<string> {
    const url = `${SystemService.apiRoot}/storeMessage`;

    return fetchToJsonWithErrorHandling(
      url, {
        method: "GET",
        mode: "cors",
      },
    ).catch((error: Error) => {
      console.error(error.stack);
      throw error;
    });
  }

  /**
   * 商品を検索します。
   * @param category カテゴリー
   * @param word タイトル
   */
  public static async search(category: string, word: string): Promise<ProductVO[]> {
    const url = new URL(`${SystemService.apiRoot}/search`);
    url.searchParams.set("category", category);
    url.searchParams.set("word", word);

    return fetchToJsonWithErrorHandling(
      url, {
        method: "GET",
        mode: "cors",
      },
    ).catch((error: Error) => {
      console.error(error.stack);
      throw error;
    });
  }

  /**
   * PDF の URI を取得します。
   */
  public static getPdfUrl(contentId: number): string {
    const url = new URL(`${SystemService.apiRoot}/attachedpdf`);
    url.searchParams.append("contentId", contentId.toString());
    return url.toString();
  }

  /**
   * PDF を取得します。
   * @returns PDF の BLOB オブジェクト。
   */
  public static async getPdf(contentId: number): Promise<Blob> {
    const accessToken: string | null = Vue.$cookies.get(SystemService.tokenKey);
    const url: string = SystemService.getPdfUrl(contentId);

    return fetchWithErrorHandling(url, {
      method: "get",
      mode: "cors",
      headers: {
        // Authorization: `Bearer ${accessToken}`,
        Accept: "application/pdf",
        "Content-Type": "application/pdf",
      },
    })
      .then((data: Response) => {
        console.log("data", data);
        return data.blob();
      })
      .catch((error: Error) => {
        console.error("PDF の取得に失敗しました。", error);
        throw error;
      });
  }
}
